import styled from 'styled-components';
import { deviceBreakpoints, variables } from 'variables';

export const NewVMStep6SC = styled.div`
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.pageBackgroundColor};
  width: 100%;
  padding: ${variables.pageContentPadding}px;
  // padding-top: 80px;
  padding-top: 60px;
  border-bottom: 4px solid ${(props) => props.theme.primaryDarkColor};
  padding-bottom: 0px;
  padding-right: 0px;
  @media only screen and (max-width: ${deviceBreakpoints.mobile}px) {
    padding-top: 0;
  }
`;

export const AuthenticationSteps = styled.div`
  margin: 2.5rem 0rem 4rem 0rem;
  padding-bottom: 15px;
  padding-right: 15px;
`;
